import { UserEmploymentFields, UserFinanceFields } from '../data/User';

export const setUserAddressData = (data: any) => ({
  street: data.address.street !== null ? data.address.street : '',
  city: data.address.city !== null ? data.address.city : '',
  state: data.address.state !== null ? data.address.state : '',
  postalCode: data.address.postalCode !== null ? data.address.postalCode : '',
  country: data.address.country !== null ? data.address.country : '',
});

export const setUserEducationData = (data: any) => ({
  university: data.education && data.education.university !== null ? data.education.university : '',
  graduationYear: data.education && data.education.graduationYear !== null ? data.education.graduationYear : '',
  gpa: data.education && data.education.gpa !== null ? data.education.gpa : '',
  maxGPA: data.education && data.education.maxGPA !== null ? data.education.maxGPA : '',
  degree: data.education && data.education.degree !== null ? data.education.degree : '',
  major: data.education && data.education.major !== null ? data.education.major : '',
  stem: data.education && data.education.stem !== null ? data.education.stem : false,
});

export const setUserRecruitmentData = (data: any) => ({
  englishProficiency: data.recruitment && data.recruitment.englishProficiency !== null ? data.recruitment.englishProficiency : '',
  codingProficiency: data.recruitment && data.recruitment.codingProficiency !== null ? data.recruitment.codingProficiency : '',
  roleInterest: data.recruitment && data.recruitment.roleInterest !== null ? data.recruitment.roleInterest : [],
});

export const setUserEmploymentData = (data: any) => ({
  employer: data.employment && data.employment.employer !== null ? data.employment.employer : '',
  business: data.employment && data.employment.business !== null ? data.employment.business : '',
  participationPermitted:
    data.employment && data.employment.participationPermitted !== null ? data.employment.participationPermitted : false,
  finance: data.employment && data.employment.finance !== null ? data.employment.finance : false,
  title: data.employment && data.employment.title !== null ? data.employment.title : '',
  description: data.employment && data.employment.description !== null ? data.employment.description : '',
  nonPublicInformation: data.employment && data.employment.nonPublicInformation !== null ? data.employment.nonPublicInformation : false,
});

export const setUserEmploymentDatSecond = (data: any) => ({
  investmentAdvisory: data.employment && data.employment.investmentAdvisory !== null ? data.employment.investmentAdvisory : false,
  brokerage: data.employment && data.employment.brokerage !== null ? data.employment.brokerage : false,
  fundamentalResearch: data.employment && data.employment.fundamentalResearch !== null ? data.employment.fundamentalResearch : false,
  proprietaryTrading: data.employment && data.employment.proprietaryTrading !== null ? data.employment.proprietaryTrading : false,
  serviceEngagement: data.employment && data.employment.serviceEngagement !== null ? data.employment.serviceEngagement : false,
  exposureStatus: data.employment && data.employment.exposureStatus !== null ? data.employment.exposureStatus : false,
  employerServices: data.employment && data.employment.employerServices !== null ? data.employment.employerServices : '',
  exposureDetails: data.employment && data.employment.exposureDetails !== null ? data.employment.exposureDetails : '',
});

export const setUserData = (data: any) => ({
  ...data,
  telephone: data.telephone !== null ? data.telephone : '',
  presently_employed: data.employment === null ? false : true,
  employment: { ...setUserEmploymentData(data), ...setUserEmploymentDatSecond(data) },
  address: setUserAddressData(data),
  education: setUserEducationData(data),
  recruitment: setUserRecruitmentData(data),
});

export const userFinanceFieldsValitation = (fields: any) => {
  let financeIsValid = true;

  UserFinanceFields.forEach((field: string) => {
    if (!fields.getIn([field, 'valid'])) {
      financeIsValid = false;
    }
  });

  return financeIsValid;
};

export const userEmploymentFieldsValitation = (fields: any) => {
  const finance = fields.getIn(['finance', 'value']);
  const employerFields = UserEmploymentFields.shift().slice(0, 7);
  let employmentIsValid = true;

  employerFields.forEach((field: string) => {
    if (!fields.getIn([field, 'valid'])) {
      employmentIsValid = false;
    }
  });

  if (finance) {
    return employmentIsValid && userFinanceFieldsValitation(fields);
  }

  return employmentIsValid;
};
